<!-- Ready to join -->
<div class="ready-to-join">
  <div class="container">
    <h3 i18n="@@readyToJoinTitle">Ready to join?</h3>
    <p i18n="@@readyToJoinDescription">Join today</p>
    <a [href]="urlSignUp" target="_blank" class="btn btn-primary" i18n="@@getStartedButton">Get started</a>
  </div>
</div>

<!-- Alliances -->
<div class="partner-area partner-section" *ngIf="viewAlliances">
  <div class="container">
    <h5 i18n="@@alliancesTitle">Strategic alliances around the world</h5>
    <div class="partner-inner">
      <div class="row" *ngFor="let item of partnershipsData">
        <app-partner [partner]="item"></app-partner>
      </div>
    </div>
  </div>
</div>
